import { render, staticRenderFns } from "./trash-paper-popup.html?vue&type=template&id=6ca0d0d8&scoped=true&"
import script from "./trash-paper-popup.js?vue&type=script&lang=js&"
export * from "./trash-paper-popup.js?vue&type=script&lang=js&"
import style0 from "./trash-paper-popup.scss?vue&type=style&index=0&id=6ca0d0d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca0d0d8",
  null
  
)

export default component.exports